'use strict';

import register from './core';
import '../functions/jquery-global.js';
import flatpickr from "flatpickr";
import { Sweden } from 'flatpickr/dist/l10n/sv.js';

//How to use add : Registrer data-component="event-picker"
//Add any of the elemete id ex (#event-start-date) to the input element you want to use the date-picker on.

export function dateValidation(dateFrom, dateTo) {
  //console.log(dateFrom + " " + dateTo)
  return dateFrom < dateTo;  
}

register('project-date-picker', function (element) {
  var $element = $(element);
  var eventStartDate = $element.find("#project-start-date");
  var eventEndDate = $element.find("#project-end-date");

  var datePickerConfig = {
    dateFormat: "Y-m-d",
    locale: "sv",
    allowInput: true,
    onChange: function (selectedDates, dateStr, instance) {
      validate();
    }
  };
  flatpickr.localize(Sweden);

  flatpickr(eventStartDate, datePickerConfig);
  flatpickr(eventEndDate, datePickerConfig);

  var validate = function () {
    var eventStart = eventStartDate.val();
    var eventEnd = eventEndDate.val();
    if (!dateValidation(eventStart, eventEnd)) {
      $("#error").show();
      $(":submit").prop("disabled", true);
    }
    else {
      $("#error").hide();
      $(":submit").prop("disabled", false);
    }
  };
});

register('input-counter', function (element) {
  let $counterElm = $(element);
  if ($counterElm.attr('data-target') == undefined)
    return;

  let $targetElm = $($counterElm.attr('data-target'));
  if ($targetElm.length < 1)
    return;

  let $targetText = $counterElm.attr('data-text');

  if ($targetElm.attr('maxlength') == undefined) {
    $targetElm.attr('maxlength', 80)
  }

  let maxLength = parseInt($targetElm.attr('maxlength'));
  if (maxLength == NaN)
    return;

  let updateCounter = function () {
    let charCountr = maxLength - $targetElm.val().length;
    $counterElm.text(charCountr + " " + $targetText);
  };

  $targetElm.on('change', updateCounter);
  $targetElm.on('keyup', updateCounter);

  updateCounter();
});

